import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {PLACEHOLDER_SCHEDULE_ID} from "@irati/insights/constants/schedule"
import {Mutation} from "../.."
import Query from "../../../query/Query"
import {cycleFieldsFragment, cycleFieldsWizardFragment} from "../../../gql/fragments/schedule"
import {CLONE_PREFIX} from "../../../constants"

const createCycle = gql`
  mutation CreateCycleWizard($params: ScheduleInput!) {
    createSchedule(schedule: $params) {
      ...cycleFieldsWizard
    }
  }
  ${cycleFieldsWizardFragment}
`

const updateCycle = gql`
  mutation UpdateCycleWizard($params: ScheduleInput!) {
    schedule(schedule: $params) {
      ...cycleFieldsWizard
    }
  }
  ${cycleFieldsWizardFragment}
`

const localQuery = gql`
  query LocalQueryUpdateCycleWizard {
    insWizard @client {
      cycle {
        ...cycleFields
      }
    }
    insGlobal @client {
      tenant
      cycleId
    }
  }
  ${cycleFieldsFragment}
`

const UpdateCycle = ({children, onCompleted, ...props}) => {
  return (
    <Query query={localQuery}>
      {({
        data: {
          insWizard: {cycle},
          insGlobal: {tenant, cycleId}
        },
        client
      }) => {
        const variables = {params: {...cycle, tenant, id: cycle.id.replace(CLONE_PREFIX, "")}}
        return (
          <Mutation
            variables={variables}
            mutation={cycleId === PLACEHOLDER_SCHEDULE_ID ? createCycle : updateCycle}
            onCompleted={(data) => {
              const {createSchedule} = data
              if (createSchedule) {
                client.writeData({data: {insGlobal: {cycleId: createSchedule.id, __typename: "InsGlobal"}}})
              }
              onCompleted(data)
            }}
            {...props}>
            {(mutate, apolloState) => {
              return children(mutate, apolloState)
            }}
          </Mutation>
        )
      }}
    </Query>
  )
}

UpdateCycle.propTypes = {
  children: PropTypes.func.isRequired,
  onCompleted: PropTypes.func
}

UpdateCycle.defaultProps = {
  onCompleted: () => null
}

export default UpdateCycle
